module.exports = __webpack_public_path__ + "static/media/Agri-Investors - GBR Care Infographic Desktop 16-05-2024  C.74de9292.gif";